/** Data a card can request through `decisively.data.get` (data bridge v2). Shared by the iframe SDK and the host. */
export const CARD_DATA_KINDS = [
  "session",
  "attributeValues",
  "sessionGraph",
  "contacts",
  "ruleGraph",
  "decisionReport",
  "interaction",
  "events",
] as const;
export type CardDataKind = (typeof CARD_DATA_KINDS)[number];

/** Options for a data request. Only `interaction` takes any: the id of the interaction to fetch. */
export interface CardDataOptions {
  id?: string;
}

/** Longest interaction id a card can send. */
export const MAX_CARD_DATA_ID_LENGTH = 256;

/** Error codes a data request can reject with, in addition to the bridge's own BAD_REQUEST and RATE_LIMITED. */
export const CARD_DATA_ERROR_CODES = [
  "FORBIDDEN",
  "NOT_FOUND",
  "NOT_AVAILABLE",
  "CONTEXT_CHANGED",
  "DATA_UNAVAILABLE",
] as const;

export function isCardDataKind(value: unknown): value is CardDataKind {
  return typeof value === "string" && (CARD_DATA_KINDS as readonly string[]).includes(value);
}

/** Whether `id` is acceptable for a kind: required (a non-empty string) for `interaction`, absent for every other kind. */
export function isValidCardDataId(kind: CardDataKind, id: unknown): boolean {
  if (kind !== "interaction") return id === undefined;
  return typeof id === "string" && id.length > 0 && id.length <= MAX_CARD_DATA_ID_LENGTH;
}
